<template>
  <div class="order-title">{{ $t('CustomSpus.ShoppingCart.shippingAddress') }}</div>
  <div v-if="props.tableRefList.length < 1"
       class="address-flex">
    <div class="address-title">{{ $t('CustomSpus.ShoppingCart.noShippingAddress') }}</div>
    <a-button type="primary"
              @click="changeAddress">{{ $t('CustomSpus.ShoppingCart.addAddress') }} </a-button>
  </div>
  <div v-else
       class="order-addressBox">
    <div v-for="(arrayItem, arrayIndex) in tableRefData"
         class="order-addressBox">
      <div v-if="arrayItem[0]"
           class="order-addressContent">
        <div class="order-addressContent-name">{{ arrayItem[0].address?.name }}</div>
        <div class=order-addressContent-phone>{{ arrayItem[0].address?.phone }}</div>
        <div v-if="arrayItem?.length > 0"
             class=order-addressContent-address>
          {{ arrayItem[0].address?.province.name + arrayItem[0].address?.district.name +
            arrayItem[0].address?.district.name + arrayItem[0].address?.street.name + arrayItem[0].address?.address }}
        </div>
        <div class="order-addressContent-side">
          <div class="order-addressContent-express">
            <span style="color: #999;">
              <a-dropdown>
                <a class="ant-dropdown-link expressBox">
                  <CaretRightOutlined class="expressicon" />
                  {{ arrayItem[0].express_company_id === 17 ? $t('CustomSpus.ShoppingCart.selfPickupShort') :
                    props.expressList.find(item => item.id ===
                      arrayItem[0].express_company_id)?.name ?? $t('CustomSpus.ShoppingCart.expressService') }}
                </a>
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-for="item in props.expressList"
                                 @click="orderExpressChange(item.id, arrayItem)">{{ item.name }}</a-menu-item>
                    <a-menu-item @click="orderExpressChange(17, arrayItem)">{{
                      $t('CustomSpus.ShoppingCart.selfPickupShort') }}</a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </span>
            <span v-if="!isDesign"
                  style="color: #DE4A09;">￥{{ isNaN(arrayItem[0].expressPrice) ? 0 : arrayItem[0].expressPrice
                  }}</span>
          </div>
          <a-dropdown>
            <a class="ant-dropdown-link">
              <SmallDashOutlined class="order-addressContent-icon" />
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item>
                  <div class="dropDownBox"
                       @click="addOtherAddress(arrayItem)">
                    <img class="dropDownIcon"
                         src="../../icon/order-sliceShop.png">
                    <span>{{ $t('CustomSpus.ShoppingCart.splitGoods') }}</span>
                  </div>
                </a-menu-item>
                <a-menu-item>
                  <div class="dropDownBox"
                       @click="toggleVisibility(arrayIndex)">
                    <img class="dropDownIcon"
                         src="../../icon/order-checkShop.png">
                    <span>{{ $t('CustomSpus.ShoppingCart.viewProduct') }}</span>
                  </div>
                </a-menu-item>
                <a-menu-item>
                  <div class="dropDownBox"
                       @click=orderChangeAddress(arrayItem[0].address.id)>
                    <img class="dropDownIcon"
                         src="../../icon/order-editAddress.png">
                    <span>{{ $t('CustomSpus.ShoppingCart.changeAddress') }}</span>
                  </div>
                </a-menu-item>
                <a-menu-item v-if="arrayIndex !== 0"
                             @click="deleteOtherAddress(arrayItem, arrayIndex)">
                  <div class="dropDownBox">
                    <img class="dropDownIcon"
                         src="../../icon/order-deleteAddress.png">
                    <span>{{ $t('CustomSpus.ShoppingCart.deleteAddress') }}</span>
                  </div>
                </a-menu-item>
              </a-menu>

            </template>
          </a-dropdown>
        </div>
      </div>
      <div v-if="arrayItem[0]?.express_company_id === 17"
           class="express-self-pickup">{{
             $t('CustomSpus.ShoppingCart.selfPickup') }}</div>
      <transition name="slide">
        <div v-if="visibleItems[arrayIndex]"
             class="order-shopCart">
          <ul>
            <li v-for="(item, index) in arrayItem">
              <div class="shopTitle">
                {{ item.spu_name || item.spu.name }}
                <span>x{{ item.quality }}</span>
              </div>
              <div class=shopDetail>
                <div>
                  <span>{{ $t('CustomSpus.ShoppingCart.color') }}:</span>{{
                    convertMatchAttrs(item.sku_attrs || item.sku.attrs,
                      'color') }}
                  <span>{{ $t('CustomSpus.ShoppingCart.weight') }}:</span>{{
                    convertMatchAttrs(item.sku_attrs || item.sku.attrs,
                      'weight') }}
                </div>
                <div>
                  <span>{{ $t('CustomSpus.ShoppingCart.size') }}:</span> {{
                    convertMatchAttrs(item.sku_attrs || item.sku.attrs,
                      'size') }}
                </div>
                <div v-if="isDesign">
                  <span v-for="tec in item.technology"
                        :key="tec.id"
                        style="">{{ tec.customableImageName }}:<span class="attr_color">{{ tec.name }}</span></span>
                </div>
              </div>
              <div v-if="index === arrayItem.length - 1"
                   class="retract"
                   @click="toggleVisibility(arrayIndex)">
                <img class="backIcon"
                     src="../../icon/order-back.png">
                {{ $t('CustomSpus.ShoppingCart.retract') }}
              </div>
            </li>
          </ul>
        </div>
      </transition>
    </div>

  </div>
  <!-- 修改地址弹框 -->
  <a-modal v-model:visible="addressPut"
           :title="$t('CustomSpus.ShoppingCart.addAddress')"
           :centered='true'
           :cancel-text="$t('CustomSpus.ShoppingCart.return')"
           width="754px"
           :destroy-on-close="true"
           :body-style="{ padding: 0, height: '600px' }">
    <AddressViewer ref='addressRef'
                   :is-cart="true"
                   :is-add="isAdd"
                   :select-id="selectId"
                   @close-add-modal="closeAdd">
    </AddressViewer>
    <!-- </a-radio-group> -->
    <template #footer>
      <a-button class="modal-btn btn-bgc"
                @click="addressCancel">{{ $t('CustomSpus.ShoppingCart.cancel') }}</a-button>
      <a-button type="primary"
                class="modal-btn"
                @click="addressShow">{{ $t('CustomSpus.ShoppingCart.confirm') }}</a-button>
      <a-button class="modal-btn btn-bgc"
                @click="addressAdd">{{ $t('CustomSpus.ShoppingCart.addAddress') }}</a-button>
    </template>
  </a-modal>
  <a-modal v-model:visible="orderAddressModal"
           :title="$t('CustomSpus.ShoppingCart.splitGoods')"
           :centered='true'
           :cancel-text="$t('CustomSpus.ShoppingCart.return')"
           width="1024px"
           :destroy-on-close="true"
           :body-style="{ padding: 0, height: '600px', overflow: 'auto' }"
           @ok="orderAddressOk">
    <OrderAddress :all-express-data="tableRefData"
                  :selected-items="selectedOrderAddressItem"
                  :is-design="isDesign"
                  @select-order="orderAdressSelectedItem"
                  @select-address="orderAddressSelectedAddress" />
  </a-modal>
</template>
<script lang="ts" setup>
import { ref, reactive, computed, watch } from "vue"
import AddressViewer from '../../../order-info/address/view/AddressesList.vue'
import OrderAddress from "./ShoppingCartAddress.vue"
import BigNumber from "bignumber.js"
import { fetchAddresses, getExpressRate } from "../../api/index"
import { message } from 'ant-design-vue'
import { useI18n } from "vue-i18n"
import type { ShoppingCartItem } from "../../types"
const { t } = useI18n()
//
const emits = defineEmits(['addressChange'])

const props = defineProps<{
  selectedItems: any
  expressList: any
  isDesign: boolean
  tableRefList: any
}>()
const addressRef = ref()
watch(() => addressRef.value?.address, (state) => {
  if (state && (state?.name != '' || state?.phone != '' || state?.address != '')) {
    selectAddress.value = state
    // addressPut.value = !addressPut.value
  }
}, { deep: true })
watch(() => props.tableRefList, (state) => {
  tableRefData.value = props.tableRefList
}, { deep: true })
const selectAddress = ref<any>({})
const tableRefData = ref<any[]>(props.tableRefList)
// 快递
// const expressList = ref<any[]>([])
const addresses = ref<any>([])
const tableOrderId = ref<number>()
const changeAddress = async () => {
  if (props.selectedItems.length == 0) {
    message.error("请先进行加购")
  } else {
    addressPut.value = true
    tableOrderId.value = undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = await fetchAddresses()
    addresses.value = res.addresses
  }
}
const orderChangeAddress = async (id: number) => {
  addressPut.value = true
  tableOrderId.value = id
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const res: any = await fetchAddresses()
  addresses.value = res.addresses
}
const orderExpressChange = async (expressCompanyId?: any, arrayItem?: any) => {
  if (props.isDesign) {
    for (let i = 0; i < arrayItem.length; i++) {
      const currentItem = arrayItem[i]
      currentItem.express_company_id = expressCompanyId
      currentItem.expressPrice = 0
    }
    return
  }
  const express_data = {
    express_company_id: expressCompanyId,
    destination_code: arrayItem[0].address.province.code,
    weight: weightTotal(arrayItem)
  }
  const price: any = await getExpressRate(express_data)
  for (let i = 0; i < arrayItem.length; i++) {
    const currentItem = arrayItem[i]
    currentItem.express_company_id = expressCompanyId
    if (expressCompanyId === 17) {
      currentItem.expressPrice = 0
    } else {
      currentItem.expressPrice = new BigNumber(price.price).decimalPlaces(2).toNumber()
    }
  }
  emits("addressChange")
}
// 订单总重量
const weight = ref<number>(0)
const weightTotal = (value: ShoppingCartItem[]) => {
  weight.value = 0
  let weightNum = 0
  value.forEach((item: any) => {
    const weightAttr = item.sku_attrs?.find((a: any) => {
      return a.attribute.key === 'weight'
    })
    if (weightAttr) {
      weightNum = new BigNumber(weightNum).plus(new BigNumber(weightAttr.value).times(item.quality)).decimalPlaces(2).toNumber()
      // weight.value += weightAttr.value * item.quality
    }
  })
  return weightNum
}
const orderAddressModal = ref<boolean>(false)
const selectedOriginOrderAddressItem = ref<ShoppingCartItem[]>([])
const selectedOrderAddressItem = ref<ShoppingCartItem[]>([])
const addOtherAddress = (orderTable: any) => {
  orderAddressModal.value = true
  orderAddress.value = null
  selectedOriginOrderAddressItem.value = orderTable
  selectedOrderAddressItem.value = deepCopy(orderTable)

}
const deepCopy = (value: any) => {
  if (!value) {
    return false
  }
  return JSON.parse(JSON.stringify(value))
}
const deleteOtherAddress = (currentOrder: any, currentIndex: number) => {
  for (let o = 0; o < currentOrder.length; o++) {
    let foundMatch = false
    for (let i = 0; i < tableRefData.value[0].length; i++) {
      const tableItem = tableRefData.value[0][i]
      if (tableItem.spu_name === currentOrder[o].spu_name &&
        tableItem.spu_id === currentOrder[o].spu_id &&
        tableItem.id === currentOrder[o].id &&
        convertMatchAttrs(tableItem.sku_attrs, 'size') === convertMatchAttrs(currentOrder[o].sku_attrs, 'size') &&
        convertMatchAttrs(tableItem.sku_attrs, 'color') === convertMatchAttrs(currentOrder[o].sku_attrs, 'color') &&
        convertMatchAttrs(tableItem.sku_attrs, 'weight') === convertMatchAttrs(currentOrder[o].sku_attrs, 'weight')
      ) {
        tableItem.quality += currentOrder[o].quality
        foundMatch = true
      }
    }
    if (!foundMatch) {
      const tableItem = tableRefData.value[0]
      currentOrder[o].address = tableItem[0].address
      tableItem.push(currentOrder[o])
    }
    tableRefData.value.splice(currentIndex, 1)
  }
}
const visibleItems = reactive<any>({})

const toggleVisibility = (arrayIndex: number) => {
  if (visibleItems[arrayIndex] === undefined) {
    // 默认情况下，新索引应被设置为 true
    visibleItems[arrayIndex] = true
  } else {
    visibleItems[arrayIndex] = !visibleItems[arrayIndex]
  }
}
const convertMatchAttrs = (attrs: any[], key: string) => {
  const matchAttrs = attrs.find(attrItem => {
    return attrItem.attribute.key === key
  })
  return matchAttrs.object_value ? matchAttrs.object_value.name : matchAttrs.value
}
const isAdd = ref<boolean>(false)
const addressAdd = () => {
  isAdd.value = true
}
const closeAdd = () => {
  isAdd.value = false
}
// 修改地址弹框
const addressPut = ref(false)
const addressCancel = () => {
  addressPut.value = false
}
const orderAddressItem = ref<any>([])
const selectItem = computed(() => {
  return deepCopy(props.selectedItems)
})
const selectId = ref<number>(0)
const addressShow = () => {
  if (tableOrderId.value != null && tableOrderId.value != undefined && tableRefData.value.length > 0) {
    tableRefData.value.forEach((item: any) => {
      const findData = item.find((itm: any) => itm.address.id === tableOrderId.value)
      if (findData) {
        findData.address = selectAddress.value
        orderExpressChange(item[0].express_company_id, item)
      }
    })
  } else {
    const copyObject = selectItem.value
    copyObject.forEach((item: any) => {
      item.address = selectAddress.value
      item.express_company_id = 17
    })
    tableRefData.value.push(copyObject)
    selectId.value = selectAddress.value.id
  }
  addressPut.value = false
}
const orderAdressSelectedItem = (newSelectedData: Array<any>) => {
  orderAddressItem.value = newSelectedData
}
const orderAddress = ref<any>()

const orderAddressSelectedAddress = (newAddress: any) => {
  orderAddress.value = newAddress
}
const orderAddressOk = () => {
  const transOrderAddress = deepCopy(orderAddress.value)
  const transOrderAddressItem = deepCopy(orderAddressItem.value)
  if (!orderAddress.value) {
    message.warning(t('CustomSpus.ShoppingCart.addressNotSelected'))
    return false
  } else if (orderAddressItem.value.length < 1) {
    message.warning(t('CustomSpus.ShoppingCart.productNotSelected'))
    return false
  } else {

    // 判断勾选了所有商品和所有数量的场景
    if (selectedOriginOrderAddressItem.value.length === transOrderAddressItem.length) {
      let allMatched = true

      // 检测所有的商品数量是否一致
      for (let i = 0; i < transOrderAddressItem.length; i++) {
        const originItem = selectedOriginOrderAddressItem.value.find(item => item.id === transOrderAddressItem[i].id)
        if (!originItem || originItem.quality !== transOrderAddressItem[i].quality) {
          allMatched = false
          break
        }
      }
      if (allMatched) {
        message.warning(t('CustomSpus.ShoppingCart.atLeastOneProduct'))
        return false
      }
    }

    for (let i = selectedOriginOrderAddressItem.value.length - 1; i >= 0; i--) {
      const originItem = selectedOriginOrderAddressItem.value[i]
      const matchEditItem = transOrderAddressItem.find((editedItem: any) => editedItem.id === originItem.id)
      if (matchEditItem) {
        originItem.quality = originItem.quality - matchEditItem.quality
        if (originItem.quality === 0) {
          selectedOriginOrderAddressItem.value.splice(i, 1)
        }
      }
    }

    const selectedCartItem: any = selectedOriginOrderAddressItem.value[0]
    if (selectedCartItem.express_company_id) {
      orderExpressChange(selectedCartItem.express_company_id, selectedOriginOrderAddressItem.value)
    }
    const itemsWithAddress = transOrderAddressItem.map((item: any) => ({
      ...item,
      address: transOrderAddress,
      express_company_id: 17,
      expressPrice: 0
    }))
    tableRefData.value?.push(itemsWithAddress)
    orderAddressModal.value = false
  }
  emits("addressChange")
}

</script>
<style lang="less" scoped>
.order-title {
  font-size: 16px;
  margin-bottom: 14px;
  margin-top: 20px;
}

.order-addressBox {
  .order-addressBox {
    border: 1px solid #F1F1F1;

    .order-addressContent {
      width: 100%;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .order-shopCart {
    width: 100%;
    background: #F6F6F6;
    border: 1px solid #F1F1F1;
    display: flex;
    align-items: center;

    ul {
      width: 100%;
      margin-top: 14px;
      margin-left: 25px;

      li {
        list-style-type: disc;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        margin-bottom: 20px;


        .shopTitle {
          flex: 1;
          font-size: 16px;

          span {
            margin-left: 20px;
            font-size: 16px;
            font-weight: 400;
            color: #999999;
          }
        }

        .shopDetail {
          font-size: 14px;
          font-weight: 400;
          color: #999999;

          div {
            span {
              color: #111111
            }
          }
        }

        .attr_color {
          color: #999;
          margin-right: 5px;
        }

        .retract {
          cursor: pointer;
          margin-right: 15px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          margin-left: auto;

          .backIcon {
            width: 9px;
            height: 9px;
          }

        }
      }
    }
  }

  .order-addressContent-name {
    margin-left: 14px;
    font-weight: bold;
    font-size: 14px;
    color: #111111;
  }

  .order-addressContent-phone {
    margin-left: 10px;
    font-weight: bold;
    font-size: 14px;
    color: #111111
  }

  .order-addressContent-address {
    margin-left: 40px;
    font-size: 14px;
    color: #111111
  }

  .order-addressContent-side {
    display: flex;
    align-items: center;
    margin-left: auto;

    .order-addressContent-express {
      display: inline-flex;
      align-items: flex-start;
      margin-right: 50px;

      .expressBox {
        display: inline-flex;
        align-items: flex-start;
        margin-right: 20px;
      }

      .expressicon {
        line-height: 25px;
      }
    }

    .order-addressContent-icon {
      margin-right: 14px;
    }
  }
}

.dropDownBox {
  .dropDownIcon {
    width: 15px;
    height: 16px;
  }

  span {
    margin-left: 11px;
    font-size: 14px;
    font-weight: 400;
    color: #111111;
  }
}

.address-flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .address-title {
    color: #999999;
    margin-bottom: 10px;
  }

  :deep(.ant-btn) {
    height: 40px;
    width: 120px;
  }
}

.express-self-pickup {
  margin-left: 14px;
  color: #999999;
}
</style>
